import { ReactElement } from 'react'

import MotoristaRepository from 'modules/motorista/infra/repositories/MotoristaRepository'
import UpdateMotorista from 'modules/motorista/pages/UpdateMotorista'

import ConsultZipCodeImpl from '../../../user/domain/usecases/ConsultZipCodeImpl'
import UserRepository from '../../../user/infra/repositories/UserRepository'
import UpdateMotoristaImpl from '../../domain/usecases/UpdateMotoristaImpl'

export const UpdateMotoristaFactory = (): ReactElement => {
  const motoristaRepository = new MotoristaRepository()
  const userRepository = new UserRepository()
  const updateMotorista = new UpdateMotoristaImpl(motoristaRepository)
  const consultZipCode = new ConsultZipCodeImpl(userRepository)

  return (
    <UpdateMotorista
      updateMotorista={updateMotorista}
      consultZipCode={consultZipCode}
    />
  )
}
